module.exports = __webpack_public_path__ + "package3.png?ca3ea5bdb1ed7adf80881544ed2395b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/package3.png
// module id = 28
// module chunks = 0